module.exports = require("swa-bootstrap-corporate-landing-home-page/analytics-query-parameters");